import createChangedSkillEntry from '../helpers/createChangedSkillEntry.js'
import isSkillChanged from '../helpers/isSkillChanged.js'
import isEmpty from '../helpers/isEmpty.js'
//---------------------
// track skill changes
//---------------------
export default function trackSkillChanges({
  skill,
  original_skills,
  changed_skills,
  character_id,
  delete: del = false, // used to remove entry from changed_skills where is new local skill (not written to db yet)
} = {}) {
  //----------
  // declares
  //----------
  let skill_changed_parm = {}
  const skill_name = skill.display_name ? skill.display_name : skill.name
  console.log('----------------------------------')
  console.log('IN trackSkillChanges....')
  console.log('trackSkillChanges - skill = ', skill)
  console.log('trackSkillChanges - skill.display_name = ', skill.display_name)
  console.log('trackSkillChanges - skill.name = ', skill.name)
  console.log('trackSkillChanges - skill_name = ', skill_name)
  console.log('----------------------------------')
  //=================================================================================
  // INTERNAL FUNCTION: _getArraySkill
  // ----------------------------------
  function _getArraySkillIndex({ array = [], skill = {} } = {}) {
    //----------
    // declares
    //----------
    let idx = -1
    //----------------------------
    // defense against empty args
    //----------------------------
    if (isEmpty(array) || isEmpty(skill)) {
      return idx
    }
    // console.log('------------------------------------')
    // console.log('_getArraySkillIndex - array = ', window.$deepCopy(array))
    // console.log('_getArraySkillIndex - skill = ', window.$deepCopy(skill))
    //------------------------------------
    // find by id first (existing skill)
    //------------------------------------
    idx = array.findIndex((c) => c.id === skill.id)
    //-----------------------------------
    // else find by display_name or name
    //-----------------------------------
    if (idx === -1) {
      // Normalise to a single comparison key that prefers display_name
      const skillKey =
        skill.display_name && skill.display_name !== '' ? skill.display_name : skill.name

      idx = array.findIndex((c) => {
        const candidateKey = c.display_name && c.display_name !== '' ? c.display_name : c.name
        return candidateKey === skillKey
      })
      // console.log('_getArraySkillIndex - idx = ', idx)
    }
    return idx
  }
  //=================================================================================
  // MAIN FLOW
  // ----------
  //---------------------
  // check args received [changed_skills could be empty if no skill changes (yet)]
  //---------------------
  if (isEmpty(skill) || isEmpty(original_skills) || changed_skills === undefined) {
    return []
  }
  /*
  ------------------------------------------------------------------------------------------------------------------------------------
   CHANGED ARRAY    ORIGINAL ARRAY     PARM ACTION        PARM DEL      CHANGED ARRAY ACTION
  ---------------  ----------------   ------------       ----------    -----------------------
  A.    No               No               ADD                 -        add (e.g. new skill, runecasting skill)          
  B.    No               Yes              UPDATE              -        add existing character skill update
  C.    Yes              Yes              UPDATE/REMOVE       -        further character skill update or reverting to original)
  D1.   Yes              No               ADD               TRUE       remove local new skill (not yet written to db)
  D2.   Yes              No               ADD               FALSE      update same ADD entry (further updates having flagged addition)
  -------------------------------------------------------------------------------------------------------------------------------------
  */
  //--------------------------------------------------------------------------------------------------------------------------------------
  // find skill in change array (use id if existing skill - otherwise use (a) display_name (e.g. runecasting) or (b) name for new skills
  //--------------------------------------------------------------------------------------------------------------------------------------
  const changed_idx = _getArraySkillIndex({ array: changed_skills, skill })
  // console.log('trackSkillChanges - changed_skills = ', window.$deepCopy(changed_skills))
  // console.log('trackSkillChanges - changed_idx = ', changed_idx)
  //---------------------------------------------------------------------
  // find skill in original array (wont be an original entry without id)
  //---------------------------------------------------------------------
  const original_idx = _getArraySkillIndex({ array: original_skills, skill })
  // console.log('trackSkillChanges - original_skills = ', window.$deepCopy(original_skills))
  // console.log('trackSkillChanges - original_idx = ', original_idx)
  //=========================================================================================================================
  // A. where skill NOT in change array + NOT in original array (adding new skill)
  //-------------------------------------------------------------------------------
  if (changed_idx == -1 && original_idx == -1) {
    console.log('A. SKILL NOT IN CHANGED OR ORIGINAL ARRAY: ' + skill_name)
    //---------------------
    // add new skill entry
    //---------------------
    skill_changed_parm = createChangedSkillEntry({
      name: skill_name,
      action: 'ADD',
      payload: {
        character: character_id ? character_id : null,
        skill: skill.skill ? skill.skill : null, // static skill id
        ticks: skill.ticks,
        training: skill.training,
        favourite: Boolean(skill.favourite),
      },
    })
    changed_skills.push(skill_changed_parm)
    //=========================================================================================================================
    // B. where skill NOT in change array + IS in original array (deleting or updating existing character skill)
    //-----------------------------------------------------------------------------------------------------------
  } else if (changed_idx == -1 && original_idx !== -1) {
    console.log('B. SKILL NOT IN CHANGED ARRAY + IS IN ORIGINAL ARRAY: ' + skill_name)
    //--------------------------------
    // where deleting character skill
    //--------------------------------
    if (del) {
      console.log('B1. CREATE DELETION ENTRY')
      //--------------------
      // add deletion entry
      //--------------------
      skill_changed_parm = createChangedSkillEntry({
        name: skill_name,
        action: 'DELETE',
        // always use id from original_skills to ensure we have the real
        // character_skill id even if the working skill object is a clone
        // or is missing its id field
        id: original_skills[original_idx].id, // character_skill id
      })
      //------------------
      // add update entry
      //------------------
    } else {
      console.log('B2. CREATE UPDATE ENTRY')
      skill_changed_parm = createChangedSkillEntry({
        name: skill_name,
        action: 'UPDATE',
        // always use id from original_skills as source of truth
        id: original_skills[original_idx].id, // character_skill id
        payload: {
          ticks: skill.ticks,
          training: skill.training,
          favourite: Boolean(skill.favourite),
        },
      })
    }
    changed_skills.push(skill_changed_parm)
    //=========================================================================================================================
    // C. where skill IS in change array + IS in original array (updating existing change entry/remove if reverted)
    //--------------------------------------------------------------------------------------------------------------
  } else if (changed_idx !== -1 && original_idx !== -1) {
    console.log('C. SKILL IS IN CHANGED ARRAY + IS IN ORIGINAL ARRAY: ' + skill_name)
    console.log('C1. CHECK IF SKILL CHANGED')
    //--------------------------------
    // where deleting character skill
    //--------------------------------
    if (del) {
      console.log('C2. CREATE DELETION ENTRY')
      //---------------------------------
      // remove change entry where found
      //---------------------------------
      changed_skills.splice(changed_idx, 1)
      //--------------------
      // add deletion entry
      //--------------------
      skill_changed_parm = createChangedSkillEntry({
        name: skill_name,
        action: 'DELETE',
        // always use id from original_skills as source of truth
        id: original_skills[original_idx].id, // character_skill id
      })
      changed_skills.push(skill_changed_parm)
      //--------------
      // not deleting
      //--------------
    } else {
      //-----------------------------------------------------------------
      // check if values changed (could have reverted back to originals)
      //-----------------------------------------------------------------
      let skill_changed = isSkillChanged(original_skills[original_idx], skill)
      //---------------
      // value changed
      //---------------
      if (skill_changed) {
        console.log('C3. SKILL VAL CHANGED - UPDATE ENTRY: ' + skill_name)
        //--------------------
        // update skill entry
        //--------------------
        changed_skills[changed_idx].payload.ticks = skill.ticks
        changed_skills[changed_idx].payload.training = skill.training
        changed_skills[changed_idx].payload.favourite = Boolean(skill.favourite)
        //---------------------------------------
        // value is original - remove from array
        //---------------------------------------
      } else {
        console.log('C4. SKILL NOT CHANGED - REMOVE ENTRY: ' + skill_name)
        changed_skills.splice(changed_idx, 1)
      }
    }
    //=========================================================================================================================
    // D. where skill IS in change array + NOT in original array (updating add entry OR remove if deleting local new skill)
    //----------------------------------------------------------------------------------------------------------------------
  } else {
    console.log('D. SKILL IS IN CHANGED ARRAY + NOT IN ORIGINAL ARRAY: ' + skill_name)
    //---------------------------------
    // where local skill being deleted
    //---------------------------------
    if (del) {
      console.log('D1. NEW SKILL BEING DELETED - REMOVE ENTRY: ' + skill_name)
      changed_skills.splice(changed_idx, 1)
    } else {
      console.log('D2. UPDATE THE UPDATE ENTRY')
      //--------------------
      // update skill entry
      //--------------------
      changed_skills[changed_idx].payload.ticks = skill.ticks
      changed_skills[changed_idx].payload.training = skill.training
      changed_skills[changed_idx].payload.favourite = Boolean(skill.favourite)
    }
  }
  console.log('FINAL CHANGED SKILLS ARRAY = ', changed_skills)
  return changed_skills
}
